import { useEffect } from "react";

interface Props {
  src: string;
  onClose: () => void;
}

export default function IllustrationLightbox({ src, onClose }: Props) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/96 animate-fadeIn cursor-pointer"
      onClick={onClose}
    >
      {/* Close button */}
      <button
        className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center text-white/50 hover:text-white border border-white/15 hover:border-white/40 transition-all duration-200 cursor-pointer"
        onClick={onClose}
        aria-label="Close"
      >
        <i className="ri-close-line text-lg" />
      </button>

      {/* Hint */}
      <p className="absolute bottom-5 left-1/2 -translate-x-1/2 font-['Share_Tech_Mono'] text-white/20 text-xs tracking-[0.2em] uppercase whitespace-nowrap">
        Click anywhere or press Esc to close
      </p>

      {/* Image */}
      <div
        className="relative max-w-[90vw] max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt="Illustration"
          className="max-w-[90vw] max-h-[90vh] object-contain"
          style={{ boxShadow: "0 0 80px rgba(0,0,0,0.8)" }}
        />
      </div>
    </div>
  );
}
